import { z } from 'zod';

import { ParticipantZod } from 'types/zod/participant';
import { ParticipantRoleZod } from 'types/zod/participant-role';

export const ParticipantInDocumentZod = ParticipantZod.and(
    z.object({
        roles: z.array(ParticipantRoleZod).optional(),
    }),
);

export type ParticipantInDocument = z.infer<typeof ParticipantInDocumentZod>;
